import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'bau365-search-trigger',
  templateUrl: './search-trigger.component.html',
  styleUrls: ['./search-trigger.component.scss'],
})
export class SearchTriggerComponent {
  @Input() size: string | undefined | null;
  @Input() searchSuggestions: string[] | null = [];
  @Output() searchTermChange = new EventEmitter<string>();
  @Output() searchTermSubmit = new EventEmitter<void>();

  cacheKey = 'newsfeed-search';
  placeholder = $localize`:@@featureNewsfeed-searchText-placeholder:INSIGHTS durchsuchen`;

  onSearchTermChanged(searchTerm: string): void {
    this.searchTermChange.emit(searchTerm);
  }

  onSearchTermSubmitted(): void {
    this.searchTermSubmit.emit();
  }
}
